export type StaticTextTranslator = (englishText: string) => string;

export const translateIdentity: StaticTextTranslator = (text) => text;
